// extracted by mini-css-extract-plugin
export var bubble = "_4d-0";
export var container = "_4d-f";
export var contrastBorder = "_4d-g";
export var greyOut = "_4d-2";
export var initialsColor0 = "_4d-3";
export var initialsColor1 = "_4d-4";
export var initialsColor10 = "_4d-d";
export var initialsColor11 = "_4d-e";
export var initialsColor2 = "_4d-5";
export var initialsColor3 = "_4d-6";
export var initialsColor4 = "_4d-7";
export var initialsColor5 = "_4d-8";
export var initialsColor6 = "_4d-9";
export var initialsColor7 = "_4d-a";
export var initialsColor8 = "_4d-b";
export var initialsColor9 = "_4d-c";
export var initialsWrapper = "_4d-1";
export var large = "_4d-l";
export var medium = "_4d-k";
export var mediumSmall = "_4d-j";
export var mediumSmallMedium = "_4d-o";
export var micro = "_4d-h";
export var small = "_4d-i";
export var tiny = "_4d-n";
export var xTiny = "_4d-m";